import { getRateCardSeed } from './documentCompensation'
import { isUsageBasedUnitType } from './unitTypeHelpers'
import type { PricingMode } from '../types/agreement'

export interface RateCardLineItemDraft {
  id: string
  description: string
  quantity: number
  is_variable: boolean
  unit_type: string
  unit_price: number
  total_price: number
  sort_order: number
}

export function hasRateCardSeed(serviceType: string | null | undefined): boolean {
  return getRateCardSeed(serviceType).length > 0
}

export function isRateCardMode(pricingMode: PricingMode | undefined): boolean {
  return pricingMode === 'rate_card'
}

/** Build variable line items from the service-type rate-card seed. */
export function buildRateCardLineItems(
  serviceType: string | null | undefined,
  startSortOrder = 0
): RateCardLineItemDraft[] {
  const seeds = getRateCardSeed(serviceType)
  return seeds.map((seed, index) => {
    const isVariable = isUsageBasedUnitType(seed.unit_type) || seed.unit_type !== 'flat_rate'
    return {
      id: crypto.randomUUID(),
      description: seed.description,
      quantity: 0,
      is_variable: isVariable,
      unit_type: seed.unit_type,
      unit_price: seed.unit_price,
      total_price: 0,
      sort_order: startSortOrder + index,
    }
  })
}
